import Button from "@/components/base/Button";
import MapEmbed from "@/components/feature/MapEmbed";
import { useSiteData } from "@/context/SiteDataContext";
import { useT } from "@/lib/useSiteText";

export default function HomeLocation() {
  const { data } = useSiteData();
  const t = useT();
  const etiqueta = t("home.ubicacion.etiqueta");
  const descripcion = t("home.ubicacion.descripcion");
  const lista = t("home.ubicacion.lista")
    .split("\n")
    .map((l) => l.trim())
    .filter(Boolean);

  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            {etiqueta && <span className="text-sm font-semibold text-accent-600">{etiqueta}</span>}
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
              {t("home.ubicacion.titulo")}
            </h2>
            {descripcion && (
              <p className="mt-4 text-base md:text-lg text-foreground-600 leading-relaxed">{descripcion}</p>
            )}
            <ul className="mt-6 space-y-3">
              {lista.map((item, i) => (
                <li key={`${i}-${item}`} className="flex items-center gap-3 text-sm md:text-base text-foreground-700">
                  <span className="w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center">
                    <i className="ri-check-line text-sm" />
                  </span>
                  {item}
                </li>
              ))}
            </ul>
            <div className="mt-8">
              <Button to="/ubicacion" icon="ri-navigation-line">
                {t("home.ubicacion.boton")}
              </Button>
            </div>
            <p className="mt-4 text-sm text-foreground-500">{data.siteSettings.address}</p>
          </div>

          <MapEmbed
            query={data.siteSettings.map_query}
            embedUrl={data.siteSettings.map_embed_url}
            linkUrl={data.siteSettings.map_url}
            className="h-[360px] md:h-[420px]"
          />
        </div>
      </div>
    </section>
  );
}